define('AwaLabs.LoyaltyMyAccount.ShoppingCheckout', [
	'underscore'
], function AwaLabsLoyaltyMyAccountShoppingCheckout(
	_
) {
	'use strict';

	return {
		mountToApp: function mountToApp(application) {
			var myAccountMenu = application.getComponent('MyAccountMenu');
			myAccountMenu.addGroup({
				id: 'loyalty',
				name: 'Loyalty Club',
				index: 6,
				url: 'loyalty'
			});
		}
	};
});
